export interface MainNavItem {
  key: 'competitions' | 'mine' | 'admin' | 'alerts' | 'profile';
  label: string;
  shortLabel: string;
  to: string;
  desktop: boolean;
  phone: boolean;
  match: (pathname: string) => boolean;
}

const under = (pathname: string, prefix: string) => pathname === prefix || pathname.startsWith(`${prefix}/`);

export function mainNavItems(isAdmin: boolean): MainNavItem[] {
  const items: MainNavItem[] = [
    { key: 'competitions', label: 'Competitions', shortLabel: 'Competitions', to: '/dashboard', desktop: true, phone: true,
      match: (p) => under(p, '/dashboard') || p.startsWith('/competition/') },
    { key: 'mine', label: 'My competitions', shortLabel: 'Mine', to: '/profile/work', desktop: true, phone: true,
      match: (p) => under(p, '/profile/work') || p.startsWith('/evaluations/') || p.startsWith('/manage/') || p.startsWith('/submission/') },
    { key: 'admin', label: 'Admin', shortLabel: 'Admin', to: '/admin', desktop: true, phone: false,
      match: (p) => under(p, '/admin') },
    { key: 'alerts', label: 'Notifications', shortLabel: 'Alerts', to: '/profile/notifications', desktop: false, phone: true,
      match: (p) => under(p, '/profile/notifications') },
    { key: 'profile', label: 'Profile', shortLabel: 'Profile', to: '/profile', desktop: false, phone: true,
      match: (p) => p === '/profile' || under(p, '/profile/settings') },
  ];
  return items.filter((item) => item.key !== 'admin' || isAdmin);
}
